import { useState } from "react";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Label } from "@progress/kendo-react-labels";
import { TextArea } from "@progress/kendo-react-inputs";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import CalenderCustomToggleButton from "components/common/CalenderCustomToogleButton";
import SubmitButton from "components/common/SubmitButton";
import { FormDate } from "components/Matters";
import styles from "./UndertakingsList.module.scss";
import { Button } from "@progress/kendo-react-buttons";
import { Checkbox } from "@progress/kendo-react-inputs";

export const UndertakingForm = ({
  onCancel,
  onSubmit,
  onDelete,
  initialValues = {},
}) => {
  const [localSubmitting, setLocalSubmitting] = useState(false);

  const handleFormSubmit = async (dataItem) => {
    setLocalSubmitting(true);
    try {
      await onSubmit(dataItem);
    } catch (error) {
      setLocalSubmitting(false);
    }
  };

  return (
    <Form
      onSubmit={handleFormSubmit}
      initialValues={initialValues}
      render={(formRenderProps) => (
        <FormElement>
          <div className="p-4">
            <div className="col-6">
              <div className="mb-3">
                <Label className="label mb-1" style={{ fontSize: "13px" }}>
                  Date
                </Label>
                <Field
                  name="date"
                  component={DatePicker}
                  toggleButton={CalenderCustomToggleButton}
                />
              </div>
            </div>
            <div className="mb-3 d-flex flex-column">
              <Label className="label mb-1" style={{ fontSize: "13px" }}>
                Details
              </Label>
              <Field
                name="description"
                component={TextArea}
                required
                placeholder="Enter undertaking details..."
                style={{
                  width: "100%",
                  maxWidth: "500px",
                  height: "62px",
                }}
              />
            </div>
            <div className="row">
              <div className="col-6">
                <div className="">
                  <Label className="label mb-1" style={{ fontSize: "13px" }}>
                    Amount
                  </Label>
                  <Field
                    name="amount"
                    component={NumericTextBox}
                    spinners={false}
                    placeholder="0.00"
                    className={styles["amount-input"]}
                    style={{
                      width: "100%",
                      height: "32px",
                    }}
                  />
                </div>
                <div className="mt-3">
                  <FormDate
                    isStyled={false}
                    label={"dateDischarge"}
                    customLabel={"Date Discharge"}
                    onChangeDate={(e, name) =>
                      formRenderProps.onChange(name, { value: e.value })
                    }
                    state={{
                      dateDischarge:
                        formRenderProps?.valueGetter &&
                        formRenderProps.valueGetter("dateDischarge"),
                    }}
                  />
                </div>
              </div>

              <div className={`col-6 mt-auto `}>
                <Field
                  name="financial"
                  component={Checkbox}
                  label="Financial (Ring Fenced)"
                  className="cursor-pointer"
                  onChange={(e) => {
                    formRenderProps.onChange("financial", { value: e.value });
                  }}
                />
              </div>
            </div>
          </div>
          <div className="dialog-footer">
            {onDelete && (
              <Button
                type="button"
                onClick={onDelete}
                className="common-btn bgBtnSecondary ms-4 me-auto"
                disabled={localSubmitting}
              >
                Delete
              </Button>
            )}
            <Button
              type="button"
              onClick={onCancel}
              className="common-btn bgBtnSecondary me-3"
            >
              Cancel
            </Button>
            <SubmitButton
              type="submit"
              disabled={localSubmitting}
              isLoading={localSubmitting}
              className="me-4"
            >
              Save
            </SubmitButton>
          </div>
        </FormElement>
      )}
    />
  );
};
